import { createFileRoute } from '@tanstack/react-router'

import { SalesWinLossScreen } from './-components/win-loss-screen.tsx'

export const Route = createFileRoute('/sales/win-loss')({
  component: SalesWinLossScreen
})
